import store from "../store/index";
//------------------------------------------
// load specific combatant headline markers
//------------------------------------------
export default function loadSpecificCombatantHeadlineMarkers(idx) {
  // console.log("---------------------");
  // console.log("IN loadCombatantHeadlineMarkers");
  //---------------------------
  // set headline marker array
  //---------------------------
  let marker_array = [
    "constrained",
    "magicked_negatively",
    "magicked_positively",
    "poisoned",
    "psyched",
    "special_marker",
  ];
  let m = 0;
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  // console.log("name = " + combatants[idx].name);
  //----------------------------
  // init headline marker slots
  //----------------------------
  for (let j = 1; j <= 4; j++) {
    let headline_marker = "headline_marker" + j;
    combatants[idx][headline_marker] = "";
    // console.log("clear j = " + headline_marker)
  }
  //------------------------
  // loop thru marker array
  //------------------------
  for (let i = 0; i < marker_array.length; i++) {
    // console.log(
    //   "i = " +
    //     i +
    //     " marker = " +
    //     marker_array[i] +
    //     " value = " +
    //     combatants[idx][marker_array[i]]
    // );
    //----------------------
    // check if marker true
    //----------------------
    if (combatants[idx][marker_array[i]] == true) {
      //------------------------------------------------------
      // where true - set headline marker field for combatant
      //------------------------------------------------------
      m++;
      let headline_marker = "headline_marker" + m;
      // console.log("headline_marker = " + headline_marker);
      combatants[idx][headline_marker] = marker_array[i];
    }
  }
}
